export const allFeatures = [
	'POSIX_STATS',
	'POSIX_MMAPS',
	'POSIX_SEEKS',
	'NPROCS',
	'POSIX_TOTAL_BYTES',
	'POSIX_FILE_ALIGNMENT',
	'POSIX_MODE',
	'POSIX_MEM_ALIGNMENT',
	'POSIX_FSYNCS',
	'POSIX_AGG_PERF_BY_SLOWEST',
	'RUNTIME',
	'POSIX_OPENS',
	'POSIX_TOTAL_ACCESSES',
	'POSIX_TOTAL_FILES',
	'POSIX_BYTES_READ_PERC',
	'POSIX_UNIQUE_BYTES_PERC',
	'POSIX_READ_ONLY_BYTES_PERC',
	'POSIX_WRITE_ONLY_BYTES_PERC',
	'POSIX_UNIQUE_FILES_PERC',
	'POSIX_READ_ONLY_FILES_PERC',
	'POSIX_WRITE_ONLY_FILES_PERC',
	'POSIX_READS_PERC',
	'POSIX_RW_SWITCHES_PERC',
	'POSIX_SEQ_READS_PERC',
	'POSIX_SEQ_WRITES_PERC',
	'POSIX_CONSEC_READS_PERC',
	'POSIX_CONSEC_WRITES_PERC',
	'POSIX_FILE_NOT_ALIGNED_PERC',
	'POSIX_MEM_NOT_ALIGNED_PERC',
	'POSIX_SIZE_READ_0_100_PERC',
	'POSIX_SIZE_READ_100_1K_PERC',
	'POSIX_SIZE_READ_1K_10K_PERC',
	'POSIX_SIZE_READ_10K_100K_PERC',
	'POSIX_SIZE_READ_100K_1M_PERC',
	'POSIX_SIZE_READ_1M_4M_PERC',
	'POSIX_SIZE_READ_4M_10M_PERC',
	'POSIX_SIZE_READ_10M_100M_PERC',
	'POSIX_SIZE_READ_100M_1G_PERC',
	'POSIX_SIZE_READ_1G_PLUS_PERC',
	'POSIX_SIZE_WRITE_0_100_PERC',
	'POSIX_SIZE_WRITE_100_1K_PERC',
	'POSIX_SIZE_WRITE_1K_10K_PERC',
	'POSIX_SIZE_WRITE_10K_100K_PERC',
	'POSIX_SIZE_WRITE_100K_1M_PERC',
	'POSIX_SIZE_WRITE_1M_4M_PERC',
	'POSIX_SIZE_WRITE_4M_10M_PERC',
	'POSIX_SIZE_WRITE_10M_100M_PERC',
	'POSIX_SIZE_WRITE_100M_1G_PERC',
	'POSIX_SIZE_WRITE_1G_PLUS_PERC',
	'POSIX_ACCESS1_COUNT_PERC',
	'POSIX_ACCESS2_COUNT_PERC',
	'POSIX_ACCESS3_COUNT_PERC',
	'POSIX_ACCESS4_COUNT_PERC',
	'POSIX_LOG10_STATS',
	'POSIX_LOG10_MMAPS',
	'POSIX_LOG10_SEEKS',
	'LOG10_NPROCS',
	'POSIX_LOG10_TOTAL_BYTES',
	'POSIX_LOG10_FILE_ALIGNMENT',
	'POSIX_LOG10_MODE',
	'POSIX_LOG10_MEM_ALIGNMENT',
	'POSIX_LOG10_FSYNCS',
	'POSIX_LOG10_AGG_PERF_BY_SLOWEST',
	'RUNTIME_LOG10',
	'POSIX_LOG10_OPENS',
	'POSIX_LOG10_TOTAL_ACCESSES',
	'POSIX_LOG10_TOTAL_FILES'
];

export const absoluteFeatures = [
	'POSIX_READS_PERC',
	'POSIX_BYTES_READ_PERC',
	'POSIX_SEQ_WRITES_PERC',
	'POSIX_CONSEC_WRITES_PERC',
	'POSIX_SEQ_READS_PERC',
	'POSIX_CONSEC_READS_PERC'
];

export const fileSpecificFeatures = [
	'POSIX_UNIQUE_FILES_PERC',
	'POSIX_UNIQUE_BYTES_PERC',
	'POSIX_READ_ONLY_FILES_PERC',
	'POSIX_READ_ONLY_BYTES_PERC',
	'POSIX_WRITE_ONLY_FILES_PERC',
	'POSIX_WRITE_ONLY_BYTES_PERC'
];

export const readFeatures = [
	'POSIX_SIZE_READ_0_100_PERC',
	'POSIX_SIZE_READ_100_1K_PERC',
	'POSIX_SIZE_READ_1K_10K_PERC',
	'POSIX_SIZE_READ_10K_100K_PERC',
	'POSIX_SIZE_READ_100K_1M_PERC',
	'POSIX_SIZE_READ_1M_4M_PERC',
	'POSIX_SIZE_READ_4M_10M_PERC',
	'POSIX_SIZE_READ_10M_100M_PERC',
	'POSIX_SIZE_READ_100M_1G_PERC',
	'POSIX_SIZE_READ_1G_PLUS_PERC'
];

export const writeFeatures = [
	'POSIX_SIZE_WRITE_0_100_PERC',
	'POSIX_SIZE_WRITE_100_1K_PERC',
	'POSIX_SIZE_WRITE_1K_10K_PERC',
	'POSIX_SIZE_WRITE_10K_100K_PERC',
	'POSIX_SIZE_WRITE_100K_1M_PERC',
	'POSIX_SIZE_WRITE_1M_4M_PERC',
	'POSIX_SIZE_WRITE_4M_10M_PERC',
	'POSIX_SIZE_WRITE_10M_100M_PERC',
	'POSIX_SIZE_WRITE_100M_1G_PERC',
	'POSIX_SIZE_WRITE_1G_PLUS_PERC'
];
export const otherFeatures = [
	'users',
	'apps_short',
	'POSIX_ACCESS1_COUNT_PERC',
	'POSIX_ACCESS2_COUNT_PERC',
	'POSIX_ACCESS3_COUNT_PERC',
	'POSIX_ACCESS4_COUNT_PERC',
	'POSIX_RW_SWITCHES_PERC',
	'POSIX_FILE_NOT_ALIGNED_PERC',
	'POSIX_MEM_NOT_ALIGNED_PERC',
];
export const logFeatures = [
	'RUNTIME',
	'NPROCS',
	'POSIX_AGG_PERF_BY_SLOWEST',
	'POSIX_TOTAL_ACCESSES',
	'POSIX_TOTAL_FILES',
	'POSIX_TOTAL_BYTES',
	'POSIX_OPENS',
	'POSIX_FSYNCS',
	'POSIX_STATS',
	'POSIX_MMAPS',
	'POSIX_SEEKS',
	'POSIX_MODE',
	'POSIX_FILE_ALIGNMENT',
	'POSIX_MEM_ALIGNMENT',
];

export default allFeatures;
